import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import useAxios from "../../../hooks/useAxios";
import Header from "../../../components/Header/Header";
import StudentForm from "../../../components/SetupProfile/forms/StudentForm/StudentForm";
import { Box, CircularProgress, Typography } from "@mui/material";
import './SetupProfilePage.css';
import FamilyForm from "../../../components/SetupProfile/forms/FamilyForm/FamilyForm";
import TeacherForm from "../../../components/SetupProfile/forms/TeacherForm/TeacherForm";
import SchoolForm from "../../../components/SetupProfile/forms/SchoolForm/SchoolForm";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [];

const SetupProfilePage = () => {
  const { role, status } = useContext(AuthContext);
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const location = useLocation();  // Get location to access state
  const is_school_required = location.state?.is_school_required;
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/profile");
      if (response.data.success) {
        setProfile(response.data.data.profile); // Update status in AuthContext
        setLoading(false);
        console.log('profile: ', profile)
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user status:", error);
    }
  };

  useEffect(() => {
      const scrollableElement = document.querySelector('#root') || document.documentElement;
      scrollableElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      fetchUserProfile();
    }, []);

    useEffect(() => {
      if(profile){
        if (role === "school") {
          navigate('/payment');
        } else {
          navigate('/dashboard');
        }
      }
    }, [profile])


  // Handler for submitting profile setup data
  const handleSubmit = async (formData) => {
    try {
      const response = await axiosInstance.post("/profile/complete", formData);
      if (response.data.success) {
        return { success: true, message: response.data.message || "Profile setup successfully!", status: response.data.user.status };
      }
      return { success: false, message: response.data.message || "Unexpected error occurred." };
    } catch (error) {
      console.error("Error setting up profile:", error);
      return {
        success: false,
        message: error.response?.data?.message || "An error occurred. Please try again.",
      };
    }
  };

  // Render the appropriate form based on the role
  const renderForm = () => {
    switch (role) {
      case "student":
        return <StudentForm handleSubmit={handleSubmit} />;
      case "family":
        return <FamilyForm handleSubmit={handleSubmit} />;
      case "teacher":
        return <TeacherForm handleSubmit={handleSubmit} is_school_required={is_school_required} />;
      case "school":
        return <SchoolForm handleSubmit={handleSubmit} />;
      default:
        return <p>Form for this role is not yet available.</p>;
    }
  };

  // Render message while role is being fetched or invalid
  if (!role || loading) {
    return (
      <>
        <div className="page-content ">
        <Box className="loading-indicator" textAlign="center" mt={2}>
          <CircularProgress />
            <Typography variant="body2" mt={1}>
              Loading
            </Typography>
        </Box>
        </div>
      </>
    );
  }

  return (
    <>
      <Header navLinks={navLinks} isScrollEffect={false} />
      <div className="page-content">
        <Typography className="announcement page-title">
          Setup your Profile
        </Typography>
        {renderForm()}
      </div>
    </>
  );
};

export default SetupProfilePage;
